import Vue from 'vue'
import actions from './actions'
import getters from './getters'
import types from '/src/store/types'
import { findIndex } from 'lodash'

const state = {
  cart: {
    lines: []
  }
}

const mutations = {
  [types.cart.ADD_ITEM] (state, itemId) {
    let index = findIndex(state.cart.lines, (line) => {
      return line.id === itemId
    })

    if (index !== -1) {
      state.cart.lines[index].quantity++
    } else {
      state.cart.lines.push({
        id: itemId,
        quantity: 1
      })
    }
  },
  [types.cart.REMOVE_ITEM] (state, itemId) {
    let index = findIndex(state.cart.lines, (line) => {
      return line.id === itemId
    })

    if (index !== -1) {
      if (state.cart.lines[index].quantity > 1) {
        state.cart.lines[index].quantity--
      } else {
        state.cart.lines.splice(index, 1)
      }
    }
  },
  [types.cart.REMOVE_LINE] (state, itemId) {
    let index = findIndex(state.cart.lines, (line) => {
      return line.id === itemId
    })

    if (index !== -1) {
      state.cart.lines.splice(index, 1)
    }
  },
  [types.cart.CLEAR_CART] (state) {
    Vue.set(state.cart, 'lines', [])
    // Vue.set(state.cart, 'gifts', [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/cart/index.js